import React, { useState, useEffect } from "react";
import axios from "axios";
import { paymentService } from "../service/payment-service";
import { useHistory } from "react-router-dom";
import { config } from "../../../../enviroment";
import { Button } from "@material-ui/core";

async function generateCaptureContext(amount, connectionId) {
  return axios.post(
    config.urls.USAGE_SERVICE_URL + '/usage-service',
    { query: `{ generateCaptureContext(amount: ${amount}, connectionId: "${connectionId}") }` },
    { headers: { "Content-Type": "application/json" } }
  );
}




export default function ClickToPayComponentNSA(props) {
  const [loading, setLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(true);
  const [unifiedPayment, setUnifiedPayment] = useState(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [iframeReady, setIframeReady] = useState(false);
  const history = useHistory();

 const decodeJWT = (token) => {
    try {
      const parts = token.split(".");
      if (parts.length !== 3) throw new Error("Invalid JWT");
      let payload = parts[1];
      payload = payload.replace(/-/g, "+").replace(/_/g, "/");
      const padded = payload + "=".repeat((4 - payload.length % 4) % 4);
      return JSON.parse(atob(padded)); 
    } catch (err) {
      console.error("JWT decode failed:", err);
      return null;
    }
  };

  const handlePrePayment = async (clientReferenceCode) => {
    localStorage.setItem(
      "depositeAmount",
      (Math.round(props.formData.depositeAmount * 100) / 100).toFixed(2)
    );
    localStorage.setItem("uniqueId", props.formData.uniqueID);
    localStorage.setItem(
      "userName",
      props.formData.fusername + " " + props.formData.lusername
    );
    localStorage.setItem("email", props.formData.email);
    localStorage.setItem("mobile", props.formData.mobile);
    localStorage.removeItem("ticketno");
    localStorage.setItem("paymentType", props.paymentType);
    localStorage.setItem("paymentProcess", "Y"); 

    try {
      const prePaymentResponse = await paymentService.prePaymentProcessing(
        props.paymentType,
        props.dataObject,
        undefined,
        clientReferenceCode
      );

      let tempInput = JSON.parse(JSON.stringify(props.dataObject));
      if (tempInput?.csaAttachments?.length) {
        tempInput.csaAttachments.forEach((item) => {
          item.fileContent = "HIDDEN";
        });
      }

      localStorage.removeItem("paymentProcess");
      let dataValue = Object.assign({}, props.formData);
        dataValue.jointOwnerDetails.map((item, index) => {
          item.fileContent = "";
        });
        dataValue.csaAttachment.map((item, index) => {
          item.fileContent = "";
        });
        dataValue.FileContent = "";
        dataValue.FileContentp = "";
        dataValue.FileContentq = "";
        dataValue.FileContentAll = "";
        const Value = JSON.stringify(dataValue);
        localStorage.setItem("Value", Value);
        localStorage.removeItem("orderId");
        localStorage.setItem(
            "orderId",
            prePaymentResponse.data.prePaymentProcessing?.transaction_uuid
        );
      setLoading(false);
      return prePaymentResponse.data.prePaymentProcessing;
    } catch (err) {
      setError(true);
      setErrorMessage(
        err.message || "Prepayment processing failed, please try again."
      );
      setLoading(false);
      throw err;
    }
  };

  useEffect(() => {
    const initializePayment = async () => {
      setLoading(true);
      setError(false);
    const premise = props.formData.selectedPremise || "";
    const parsedConnectionId = premise.split(",").find(item => item.startsWith("QON"));
    const connectionId = localStorage.getItem("connectionId") || parsedConnectionId;
      try {
        const captureContextResponse = await generateCaptureContext(
          props.formData.depositeAmount,
          connectionId
        );
        const captureContextJwt = captureContextResponse.data.data.generateCaptureContext.captureContext;

        if (!captureContextJwt) {
          throw new Error("Failed to get capture context");
        }

        setConfigLoading(false);

        const decoded = decodeJWT(captureContextJwt);
        const scriptUrl = decoded?.ctx?.[0]?.data?.clientLibrary;
        const scriptIntegrity = decoded?.ctx?.[0]?.data?.clientLibraryIntegrity;

        const script = document.createElement("script");
        script.src = scriptUrl;
        if (scriptIntegrity) script.integrity = scriptIntegrity;
        script.crossOrigin = "anonymous";
        script.async = true;

        script.onload = async () => {
          if (!window.Accept) {
            setError(true);
            setErrorMessage("CyberSource Accept SDK not available");
            setLoading(false);
            return;
          }

          try {
            const acceptObj = await window.Accept(captureContextJwt);
            const uPayment = await acceptObj.unifiedPayments();
            setUnifiedPayment(uPayment);

            const paymentResult = await uPayment.show({
              containers: { paymentSelection: "#buttonPaymentListContainer" },
            });

            await handlePrePayment(decoded?.ctx?.[0]?.data?.clientReferenceInformation?.code);
            let completeResponse = await uPayment.complete(paymentResult);
            history.push({
              pathname: "/new-user-confirmation",
              state: { completeResponse },
            });
          } catch (sdkErr) {
            setError(true);
            setErrorMessage("Click to Pay payment failed");
            setLoading(false);
          }
        };

        script.onerror = () => {
          setError(true);
          setErrorMessage(
            "Failed to load payment system. Please refresh and try again."
          );
          setLoading(false);
        };

        document.head.appendChild(script);
      } catch (err) {
        setError(true);
        setErrorMessage(err.message || "Payment initialization failed");
        setLoading(false);
        setConfigLoading(false);
      }
    };

    initializePayment();
  }, []); 

  useEffect(() => {
    const container = document.getElementById("buttonPaymentListContainer");
    if (!container) return;

    const mutationObserver = new MutationObserver(() => {
      const iframe = container.querySelector("iframe");
      if (iframe) {
        mutationObserver.disconnect();
        const resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const { width, height } = entry.contentRect;
            if (width > 0 && height > 0) {
              setIframeReady(true);
              resizeObserver.disconnect();
            }
          }
        });
        resizeObserver.observe(iframe);
      }
    });

    mutationObserver.observe(container, { childList: true, subtree: true });
    return () => mutationObserver.disconnect();
  }, []);
  return (
    <div>
      <div style={{ position: "relative", display: "inline-block", marginLeft: "3px" }}>
        <div
          style={{
            width: "111px",
            height: "42px",
            overflow: "hidden",
            borderRadius: "4px",
            opacity: iframeReady ? 1 : 0,
            pointerEvents: (iframeReady) ? "auto" : "none",
              filter: "hue-rotate(200deg) saturate(2) brightness(0.8)"

          }}
        >
          <div
            id="buttonPaymentListContainer"
            style={{
              width: "134px",
              height: "158px",
              transform: "scale(0.87) translateY(1px)",
              transformOrigin: "top left",
            }}
          />
        </div>
        {!iframeReady && (
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "111px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#8d8d8d",
            borderRadius: "4px",
            zIndex: 3,
            pointerEvents: "none",
          }}>
            <span style={{
              display: "inline-block",
              width: "14px",
              height: "14px",
              border: "2px solid #bbb",
              borderTop: "2px solid #1976d2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginRight: "6px",
              flexShrink: 0,
            }} />
            <span style={{ fontSize: "11px", color: "#ffffff" }}>CREDIT CARD...</span>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        )}

       {iframeReady && (
        <div
          style={{
            position: "absolute",
            top: "-4px",
            left: "-6px",
            width: "114px",
            height: "42px",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
        <Button
        variant="contained"
        size="small"
        color="secondary"
        className={[props.baseClasses.accentButton,props.classes.buttonsMargin]}
        style={{
          width: "100%",
          height: "41px",          
          minWidth: "unset",
          padding: "0 8px",        
          lineHeight: "41px",     
          fontSize: "13px",
        }}
      >
        CREDIT CARD
      </Button>
        </div>
      )}
      </div>
    </div>
  );
}